// TODO: Replace with codegen types once backend with uplift-caps APIs is available
// These interfaces match the GraphQL schema for contractUpliftCaps query and upsertContractUpliftCaps mutation

export enum UpliftModifierEnum {
  None = 'None',
  Equals = 'Equals',
  GreaterThan = 'GreaterThan',
  LessThan = 'LessThan',
  SumOf = 'SumOf',
  MaximumOf = 'MaximumOf'
}

export enum UpliftCapRateTypeEnum {
  Index = 'Index',
  Fixed = 'Fixed'
}

export interface UpliftCapRate {
  type: UpliftCapRateTypeEnum;
  indexId: string | null;
  fixedValue: number | null;
}

export interface UpliftCap {
  id: string;
  modifier1: UpliftModifierEnum;
  endDate: string | null;
  rate1: UpliftCapRate;
  rate2: UpliftCapRate | null;
  modifier2: UpliftModifierEnum;
  rate3: UpliftCapRate | null;
  calculatedCapPercentage: number | null;
}

export interface ContractUpliftCaps {
  existingUpliftCap: UpliftCap | null;
  furtherUpliftCap: UpliftCap | null;
}

export interface UpsertContractUpliftCapsInput {
  contractId: string;
  existingUpliftCap: UpsertUpliftCapInput | null;
  furtherUpliftCap: UpsertUpliftCapInput | null;
}

export interface UpsertUpliftCapInput {
  modifier1: UpliftModifierEnum;
  endDate: string | null;
  rate1: UpliftCapRateInput;
  rate2: UpliftCapRateInput | null;
  modifier2: UpliftModifierEnum;
  rate3: UpliftCapRateInput | null;
}

export interface UpliftCapRateInput {
  type: UpliftCapRateTypeEnum;
  indexId: string | null;
  fixedValue: number | null;
}

// Query response types (matching codegen pattern)
export interface GetContractUpliftCaps {
  contractUpliftCaps: ContractUpliftCaps;
}

export interface GetContractUpliftCapsVariables {
  contractId: string;
}

// Mutation response types
export interface UpsertContractUpliftCaps {
  upsertContractUpliftCaps: ContractUpliftCaps;
}

export interface UpsertContractUpliftCapsVariables {
  input: UpsertContractUpliftCapsInput;
}
